export default __webpack_public_path__ + "static/seaview-d084989deffce75d1d79a392867b8b2c.jpg";